export default __webpack_public_path__ + "static/media/shirtly-facility.f35a497a.svg";